function headerOffset() {
    return (document.querySelector('.site-header')?.getBoundingClientRect().height ?? 0) + 12;
}

function scrollToBlock(blocks, index) {
    const target = blocks[Math.max(0, Math.min(blocks.length - 1, index))];
    if (!target) return;
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset();
    window.scrollTo({ top, behavior: 'smooth' });
}

function currentBlockIndex(blocks) {
    const offset = headerOffset();
    let bestIndex = 0;
    let bestDistance = Number.POSITIVE_INFINITY;
    blocks.forEach((block, index) => {
        const distance = Math.abs(block.getBoundingClientRect().top - offset);
        if (distance < bestDistance) {
            bestDistance = distance;
            bestIndex = index;
        }
    });
    return bestIndex;
}

document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.home-snap');
    if (!root || window.matchMedia('(max-width: 960px)').matches) return;

    const blocks = [...root.querySelectorAll('.snap-block')];
    if (blocks.length < 2) return;

    let locked = false;
    const unlock = () => { locked = false; };

    window.addEventListener('wheel', (event) => {
        if (event.target.closest('input, textarea, select, button')) return;
        if (Math.abs(event.deltaY) < 18) return;
        if (locked) return;

        const direction = event.deltaY > 0 ? 1 : -1;
        const nextIndex = currentBlockIndex(blocks) + direction;
        if (nextIndex < 0 || nextIndex >= blocks.length) return;

        event.preventDefault();
        locked = true;
        scrollToBlock(blocks, nextIndex);
        window.setTimeout(unlock, 760);
    }, { passive: false });

    window.addEventListener('keydown', (event) => {
        if (!['PageDown', 'PageUp', 'ArrowDown', 'ArrowUp'].includes(event.key)) return;
        if (event.target.closest('input, textarea, select')) return;
        event.preventDefault();
        const direction = ['PageDown', 'ArrowDown'].includes(event.key) ? 1 : -1;
        scrollToBlock(blocks, currentBlockIndex(blocks) + direction);
    });
});
